<template src="./header.html"></template>

<script lang="ts">
import globalConfig from 'init/global.config'

export default {
  data() {
    return { globalConfig }
  },
  props: {
    center: Boolean,
    description: String,
    heading: String,
    withBorder: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" src="./header.scss"></style>
